// import { getGoodsType } from 'enumeration/mall.js'
import { getOrderStatus, getOrderRefundStatus, getRefundmentType, getRefundReturn, getOnlyRefundReason, getChannelName } from 'enumeration/goods-order.js'
import { collectionsLabels, shippingMode, invoiceProvideTypesDo, invoiceObject, paymentModes, thirdStatusOptions } from 'json/mall-options'
import { sampleType, invoiceTypes, invoiceStates, invoiceForms, identityCardTypes, refundModes, userOrderTypes, newOrderStatus, paymentAccounts } from 'json/goods-order-options'
import { exportStates } from 'json'
import { cashCount, genderFormat } from '@/utils/formUtils'
import orderflowHelper from '@/config/order'
import timeutils from 'utils/wt-time-utils'
import { targetFroms } from 'json/link-manage'
import { getEnumeration } from 'enumeration'
export default {
  getMallOrders(data) {
    data.forEach((item, index) => {
      let apply = (item.refundmentDetails && item.refundmentDetails.apply) || {}
      let specificationItem = item.specificationItem || {}
      let placementDetails = item.placementDetails || {}
      let placementGoods = (item.placementDetails && item.placementDetails.goods) || {}
      let goodsItem = (item.goods && item.goods[0]) || {}
      item.created_date = timeutils.format(item.orderTime)
      item.totalAmount = item.paymentSummary && item.paymentSummary.total && '¥' + cashCount(item.paymentSummary.total, true, 2)
      item.order_status = placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE' && item.orderStatus === 'WAITING_FOR_PAYMENT' ? (item.isBalanceWaitingPayment ? '待支付尾款' : '待支付订金') : item.orderStatus && getOrderStatus(item.orderStatus)
      item.goods_name = item.goods && item.goods[0] && item.goods[0].name
      item.refund_amount = apply.amount && cashCount(apply.amount, true, 2)
      let paymentDetails = item.paymentDetails || {}
      item.channelName = paymentDetails && paymentDetails.channel && getChannelName(paymentDetails.channel)
      item.sales_price = (specificationItem.price && '¥' + cashCount(specificationItem.price, true, 2)) || (goodsItem.finalPrice && '¥' + cashCount(goodsItem.finalPrice, true, 2)) || ('¥' + '0.00')
        //   item.goods_type = goodsItem.type && getGoodsType(goodsItem.type)
      item.goods_number = placementGoods.number
      item.reality_price = (item.paymentTotal && '¥' + cashCount(item.paymentTotal, true, 2)) || '¥' + '0.00'
      item.refundmentType = apply.refundmentType && getRefundmentType(apply.refundmentType, true)
      item.orderRefundStatus = item.refundmentDetails && item.refundmentDetails.status && getOrderRefundStatus(item.refundmentDetails.status)
      item.applyTime = apply.applyTime && timeutils.format(apply.applyTime)
      item.goodsName = goodsItem.name
      item.orederType = (item.type && getEnumeration(item.type, userOrderTypes)) || null
      item.order_status = (item.orderStatus && getEnumeration(item.orderStatus, newOrderStatus)) || null
      item.lastModifiedDate = (item.lastModifiedDate && timeutils.format(item.lastModifiedDate)) || null
      item.business_source = (item.businessSource && getEnumeration(item.businessSource, targetFroms)) || null
    })
    return data
  },
  goodsOrderDetail(data) {
    let apply = (data.refundmentDetails && data.refundmentDetails.apply && data.refundmentDetails.apply) || {}
    let refundmentDetails = data.refundmentDetails || {}
    let refundStatusHistory = (data.refundmentDetails && data.refundmentDetails.refundStatusHistory) || null
    let vendorInfo = (data.goods && data.goods[0] && data.goods[0].vendorInfo) || {}
    let specificationItem = data.specificationItem || {}
    let expressDetails = data.expressDetails || {}
    let goods = (data.goods && data.goods[0]) || {}
    let extendInfo = data.extendInfo || {}
    extendInfo.child_birthday = extendInfo.childBirthday && timeutils.format(extendInfo.childBirthday, 'date')
    extendInfo.collect_time = extendInfo.collectTime && timeutils.format(extendInfo.collectTime, 'shortDatetime')
    data.third_status = (data.thirdStatus && getEnumeration(data.thirdStatus, thirdStatusOptions)) || ''
    let placementDetails = data.placementDetails || {}
    let invoice = (placementDetails && placementDetails.invoice) || {}
    let patient = data.patient || {}
    let paymentModeSummary = data.paymentModeSummary || []
    let goodsData = (data && data.goods && data.goods[0]) || {}
    let paymentSummary = data.paymentSummary || {}
    data.paymentAccount = getEnumeration(paymentSummary.paymentAccount, paymentAccounts)
    if (goodsData.goodsCompanyList && goodsData.goodsCompanyList.length) {
      goodsData.goodsCompanyList.forEach(item => {
        goodsData.goodsCompanyName = goodsData.goodsCompanyName ? goodsData.goodsCompanyName + '/' + item.name : item.name
      })
    }
    data.business_source = (data.businessSource && getEnumeration(data.businessSource, targetFroms)) || null
    data.paymentMode = (placementDetails && placementDetails.paymentMode && getEnumeration(placementDetails.paymentMode, paymentModes)) || '全款'
    specificationItem.balance_show = specificationItem.balance && cashCount(specificationItem.balance, true, 2)
    specificationItem.deposit_show = specificationItem.deposit && cashCount(specificationItem.deposit, true, 2)
    data.refundProcessMode = refundmentDetails.refundProcessMode && getEnumeration(refundmentDetails.refundProcessMode, refundModes)
    invoice.invoice_type = invoice.invoiceType && getEnumeration(invoice.invoiceType, invoiceProvideTypesDo)
    invoice.title_type = invoice.titleType && getEnumeration(invoice.titleType, invoiceObject)
    patient.sex = patient.gender && genderFormat(patient.gender)
    patient.birth_day = patient.birthday && timeutils.format(patient.birthday, 'date')
    patient.idCardType = patient.identityCardType && getEnumeration(patient.identityCardType, identityCardTypes)
    data.orderRefundStatus = data.refundmentDetails && data.refundmentDetails.status && getOrderRefundStatus(data.refundmentDetails.status)
    patient.marry = patient.married ? '已婚' : '未婚'
    if (paymentModeSummary.length) {
      paymentModeSummary.forEach(item => {
        item.amount_show = item.amount && ('¥' + cashCount(item.amount, true, 2))
      })
    }
    // let shipping=
    let paymentDetails = data.paymentDetails || {}
    let balancePaymentDetails = data.balancePaymentDetails || {}
    data.goods_name = goods.name
      // 订单价格（及优惠）相关信息
    let summaryItems = (data.paymentSummary && data.paymentSummary.items) || []
    data.totalAmount = (data.paymentSummary && data.paymentSummary.total && cashCount(data.paymentSummary.total, true, 2)) || '--'
    summaryItems.forEach(item => {
      item.amount_show = '¥' + (item.amount && cashCount(item.amount, true, 2)) || 0
    })
    data.shipingTime = expressDetails.time && timeutils.format(expressDetails.time)
    data.shippingMode = goods.shippingMode && getEnumeration(goods.shippingMode, shippingMode)
      // data.samples=expressDetails.samples&&
    data.paymentTime = paymentDetails.time && timeutils.format(paymentDetails.time)
    data.balancePaymentTime = balancePaymentDetails.time && timeutils.format(balancePaymentDetails.time)
    data.balance_show_amount = (balancePaymentDetails && cashCount(balancePaymentDetails.amount, true)) || 0
    data.balanceChannelName = balancePaymentDetails && balancePaymentDetails.channel && getChannelName(balancePaymentDetails.channel)
    if (expressDetails.samples && expressDetails.samples.length > 0) {
      expressDetails.samples.forEach(item => {
        item.sample_type = item.sampleType && getEnumeration(item.sampleType, sampleType)
      })
    }
    data.order_status = data.orderStatus && (placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE' &&
      data.orderStatus === 'WAITING_FOR_PAYMENT' ? (data.isBalanceWaitingPayment ? '待支付尾款' : '待支付订金') : getOrderStatus(data.orderStatus))
    data.payment_account = vendorInfo.paymentAccount && getEnumeration(vendorInfo.paymentAccount, collectionsLabels)
      // data.goods_type = goods.type && getGoodsType(goods.type)
    data.show_amount = (paymentDetails && cashCount(paymentDetails.amount, true)) || 0
    data.payment_total = (data.paymentTotal && cashCount(data.paymentTotal, true, 2)) || 0
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    data.refundmentType = apply.refundmentType && getRefundmentType(apply.refundmentType, true)
    data.applyTime = apply.applyTime && timeutils.format(apply.applyTime)
    data.refund_amount = apply.amount && cashCount(apply.amount, true, 2)
    apply.show_amount = apply.amount && cashCount(apply.amount, true)
    data.refunded_amount = refundmentDetails.refundedAmount && cashCount(refundmentDetails.refundedAmount, true)
    data.channelName = paymentDetails && paymentDetails.channel && getChannelName(paymentDetails.channel)
    if (apply.refundmentType === 'MONEY') {
      data.refund_resean = (apply.reason && getOnlyRefundReason(apply.reason)) || apply.reason
    } else {
      data.refund_resean = (apply.reason && getRefundReturn(apply.reason)) || apply.reason
    }
    data.refund_sampleId = apply.sampleIds && apply.sampleIds.join('/')
    data.is_got = apply.isGot ? '已收到货' : '未收到货'
    let samples = (data.expressDetails && data.expressDetails.samples) || null
    if (samples) {
      samples.forEach(item => {
        data.sampleIds = data.sampleIds ? (data.sampleIds + '/' + item.sampleId) : item.sampleId
      })
    }
    if (refundStatusHistory) {
      refundStatusHistory.forEach(item => {
        data[item.refundStatus + '_time'] = timeutils.format(item.time)
      })
    }
    data.rejectTime = refundmentDetails.rejectTime && timeutils.format(refundmentDetails.rejectTime)
    return data
  },
  getOrderInvoice(data) {
    data.forEach(item => {
      let information = item.information || {}
      let request = item.request || {}
      item.invoiceType = information.invoiceType && getEnumeration(information.invoiceType, invoiceTypes)
      item.invoiceState = item.state && getEnumeration(item.state, invoiceStates)
      item.invoiceForm = information.invoiceForm && getEnumeration(information.invoiceForm, invoiceForms)
      item.invoiceAmount = information.amount && cashCount(information.amount, true)
      item.time = request.time && timeutils.format(request.time, 'date')
    })
    return data
  },
  getOrderProgress(data) {
    if (data.items) {
      let items = data.items
      items.forEach(item => {
        item.happen_time = timeutils.format(item.time)
      })
    }
    return data
  },
  waitingForSampleRecollect(data) {
    data.forEach(item => {
      item.order_createdDate = item.orderCreatedDate && timeutils.format(item.orderCreatedDate)
      item.order_amount = item.orderAmount && cashCount(item.orderAmount, true, 2)
      item.order_status = item.state && orderflowHelper.formatOrderActions(item.state)
      item.resample_amount = item.resampleAmount && cashCount(item.resampleAmount, true, 2)
    })
    return data
  },
  exportHistoryList(data) {
    data.forEach(item => {
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
      item.exportStates = item.state && getEnumeration(item.state, exportStates)
    })
    return data
  },
  getOrderHistory(data) {
    data.forEach(item => {
      item.newSampleId = (item.expressDetails && item.expressDetails.samples && item.expressDetails.samples[0].sampleId) || item.id
    })
    return data
  }
}